import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/relatorio-faltoso-aprazamento`

    return {
        vacina: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-vacina?${urlUtil.serialize(queryParms)}`)
            },
        },
        index(queryParms) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
    }
}